// extracted by mini-css-extract-plugin
module.exports = {"bpk-aria-live--invisible":"BpkAriaLive_bpk-aria-live--invisible__ODVmN","bpk-keyframe-spin":"BpkAriaLive_bpk-keyframe-spin__NmY4Y"};